import { ToastProvider } from '@/design-system';
import { SessionExpiry } from './SessionExpiry';
import { AppShell } from './shell/AppShell';
import { ShellProvider } from './shell/ShellContext';
import { ExperienceSearchProvider } from './state/experienceSearch';
import { OverlayProvider } from './state/overlays';
import { PreferencesProvider } from './state/preferences';
import { VehicleSearchProvider } from './state/vehicleSearch';

/** Providers that need the router, around the shell. */
export function RootLayout() {
  return (
    <PreferencesProvider>
      <VehicleSearchProvider>
        <ExperienceSearchProvider>
          <OverlayProvider>
            <ToastProvider>
              <ShellProvider>
                <SessionExpiry />
                <AppShell />
              </ShellProvider>
            </ToastProvider>
          </OverlayProvider>
        </ExperienceSearchProvider>
      </VehicleSearchProvider>
    </PreferencesProvider>
  );
}
